import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { AMOUNT_LATEST_TRANSACTIONS } from '../../constants/general';

const { CONTROLLERS: { DASHBOARD_HOME: { VERSION, BASE } } } = USER;

export const useDashboardDataQuery = ({ customerId, disableSelfUpdate, transactionsAmount }: { customerId: string, disableSelfUpdate?: boolean, transactionsAmount?: number }) => useQuery(
  'dashboardData',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/?transactions=${transactionsAmount || AMOUNT_LATEST_TRANSACTIONS}`));
    return data;
  },
  {
    enabled: !disableSelfUpdate,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
  },
);
